import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export function getBillingInfo(membersGuids) {
    return http.get(API_PATHS.membersBillingInfo, { params: { membersGuids } });
}

export function updateBankingInfo(bankingInfo) {
    return http.post(API_PATHS.bankingInfo, bankingInfo);
}